import { render } from "./UserNewsList.vue?vue&type=template&id=0bf0edee&scoped=true"
import script from "./UserNewsList.vue?vue&type=script&lang=js"
export * from "./UserNewsList.vue?vue&type=script&lang=js"

import "./UserNewsList.vue?vue&type=style&index=0&id=0bf0edee&lang=css"
import "./UserNewsList.vue?vue&type=style&index=1&id=0bf0edee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf0edee"]])

export default __exports__